// src/pages/Mapa.js
import React from 'react';
import { MapPin, Filter, Layers } from 'lucide-react';

const Mapa = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">Mapa de Emergencias</h1>
          <p className="text-gray-500 mt-1">Vista geolocalizada de emergencias</p>
        </div>
        <div className="flex gap-2">
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 font-medium">
            <Layers className="w-5 h-5" />
            Capas
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-200 rounded-lg text-gray-700 hover:bg-gray-50 font-medium">
            <Filter className="w-5 h-5" />
            Filtrar
          </button>
        </div>
      </div>

      <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-sm h-[600px] flex items-center justify-center">
        <div className="text-center">
          <MapPin className="w-16 h-16 text-[#c8a88c] mx-auto mb-4" />
          <p className="text-gray-600 font-medium text-lg">Vista de Mapa Interactivo</p>
          <p className="text-sm text-gray-500 mt-2">Integración con Google Maps o Mapbox próximamente</p>
          <div className="mt-6 p-4 bg-gray-50 rounded-lg max-w-md mx-auto">
            <p className="text-sm text-gray-600">
              Aquí se mostrará un mapa interactivo con las emergencias geolocalizadas usando Latitud y Longitud de cada registro.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Mapa;